const zhCommon = {
  nav: {
    home: '首页',
    categories: '分类浏览',
    about: '关于我们',
    download: '下载APP',
  },
  footer: {
    brandDesc: '快猫短视频是一款汇聚海量原创短视频内容的平台，涵盖搞笑、生活、才艺、资讯等多元类型。随时随地发现精彩瞬间，畅享沉浸式刷视频乐趣。',
    quickLinks: '快速链接',
    categories: '热门分类',
    contact: '联系我们',
    copyright: '© 2026 快快猫短视频 版权所有',
    privacy: '隐私政策',
    terms: '用户协议',
    help: '帮助中心',
    email: 'contact@kuaikuaimao.com',
    phone: '400-888-6666',
    address: '北京市朝阳区望京科技园A座',
  },
  home: {
    heroTitle: '海量精彩内容',
    heroTitleHighlight: '随时刷',
    heroSubtitle: '汇聚搞笑、生活、才艺、资讯等多元原创短视频，加入千万用户的创作与互动社区',
    downloadApp: '下载APP',
    exploreContent: '浏览内容',
    statsUsers: '活跃用户',
    statsVideos: '原创视频',
    statsCreators: '创作者',
    featuresTitle: '为什么选择快猫短视频',
    featuresSubtitle: '我们致力于为用户提供最优质的短视频体验',
    feature1Title: '海量精选内容',
    feature1Desc: '覆盖搞笑、生活、才艺、资讯等多个领域，智能推荐算法精准推送你感兴趣的视频',
    feature2Title: '创作者社区',
    feature2Desc: '汇聚百万创作者，每个人都有机会展示才华，分享生活，获得关注与收益',
    feature3Title: '沉浸式体验',
    feature3Desc: '流畅的播放体验，简洁的交互设计，让你沉浸在精彩的短视频世界中',
    feature4Title: '随时随地',
    feature4Desc: '支持手机、平板多端同步，无论何时何地都能畅快刷视频',
    hotVideos: '热门推荐',
    hotVideosSubtitle: '千万用户正在看的热门内容',
    viewAll: '查看全部',
    categoriesTitle: '探索更多分类',
    categoriesSubtitle: '总有一类适合你的口味',
    ctaTitle: '加入快猫短视频，发现更多精彩',
    ctaSubtitle: '立即下载快猫短视频APP，开启你的精彩短视频之旅',
    ctaButton: '免费下载',
    views: '播放',
    likes: '点赞',
    readMore: '阅读全文',
  },
  category: {
    title: '分类浏览',
    subtitle: '选择你感兴趣的内容分类，发现更多精彩视频',
    allCategories: '全部分类',
    videoCount: '个视频',
    noArticles: '该分类暂无内容，去看看其他分类吧~',
    backToHome: '返回首页',
  },
  article: {
    home: '首页',
    category: '分类',
    views: '次播放',
    likes: '次点赞',
    publishedOn: '发布于',
    readTime: '阅读时间',
    author: '作者',
    tags: '标签',
    relatedArticles: '相关推荐',
    backToCategory: '返回分类',
    shareArticle: '分享文章',
  },
  about: {
    title: '关于快猫短视频',
    subtitle: '让每个人都能发现生活中的精彩瞬间',
    brandIntro: '品牌介绍',
    brandDesc: '快快猫短视频成立于2024年，是一家专注于短视频内容创作与分发的互联网平台。我们致力于为全球用户提供丰富、多元、高质量的短视频内容，涵盖搞笑、生活、才艺、资讯、美食、旅行、科技等多个领域。',
    brandVision: '我们的愿景是让每个人都能通过短视频发现生活中的美好、展示自己的才华、连接志同道合的朋友。无论你是想放松娱乐，还是想学习新技能，快猫短视频都能满足你的需求。',
    statsTitle: '平台数据',
    statsUsers: '月活跃用户',
    statsVideos: '日均上传视频',
    statsCountries: '覆盖国家和地区',
    statsPartners: '合作品牌',
    reputation: '用户口碑',
    reputationSubtitle: '来自千万用户的真实评价',
    contactTitle: '联系我们',
    contactSubtitle: '有任何问题或建议？我们很乐意听取你的意见',
    contactInfo: '联系信息',
    sendMessage: '发送消息',
    formName: '姓名',
    formEmail: '邮箱',
    formSubject: '主题',
    formMessage: '留言内容',
    formSubmit: '提交留言',
    formSuccess: '留言发送成功！我们会尽快回复你。',
    formError: '发送失败，请稍后再试。',
    formNamePlaceholder: '请输入你的姓名',
    formEmailPlaceholder: '请输入你的邮箱',
    formSubjectPlaceholder: '请选择主题',
    formMessagePlaceholder: '请输入你的留言（限500字）',
    subjectGeneral: '一般咨询',
    subjectCooperation: '商务合作',
    subjectCreator: '创作者入驻',
    subjectFeedback: '意见反馈',
    subjectOther: '其他',
    valuesTitle: '核心价值观',
    value1Title: '用户至上',
    value1Desc: '始终把用户体验放在第一位，不断优化产品功能和使用体验',
    value2Title: '内容为王',
    value2Desc: '坚持原创优质内容，建立严格的审核机制，为用户提供有价值的视频',
    value3Title: '技术驱动',
    value3Desc: '持续投入AI推荐算法研发，让每个用户都能看到自己喜欢的内容',
    value4Title: '共创共赢',
    value4Desc: '与创作者共同成长，建立公平透明的收益分配机制',
  },
  breadcrumb: {
    home: '首页',
    category: '分类',
    about: '关于我们',
  },
  scrollToTop: '回到顶部',
}

export default zhCommon